var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRtArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.879 8.41182C26.879 8.20707 26.7551 7.935 26.6295 7.80283L19.546 0.276271C19.2153 -0.0655926 18.6795 -0.105121 18.2941 0.241683C17.9494 0.552049 17.9408 1.15702 18.2595 1.49396L23.9455 7.52616L1.20129 7.52616C0.712116 7.52616 0.315918 7.92269 0.315918 8.41154C0.315918 8.90071 0.712441 9.29691 1.20129 9.29691L23.9455 9.2969L18.2595 15.3291C17.9408 15.666 17.9633 16.2562 18.2941 16.5811C18.643 16.9242 19.2205 16.8936 19.546 16.5465L26.6295 9.02024C26.8376 8.81611 26.8756 8.61939 26.879 8.41156L26.879 8.41182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRtArrow);
export default __webpack_public_path__ + "static/media/icon_rt_arrow.23461f6369c963221d09973b137ec8a0.svg";
export { ForwardRef as ReactComponent };